"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MarkdownDisplay = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _markdown = _interopRequireDefault(require("@nteract/markdown"));

var MarkdownDisplay = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(MarkdownDisplay, _React$Component);

  function MarkdownDisplay() {
    (0, _classCallCheck2["default"])(this, MarkdownDisplay);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MarkdownDisplay).apply(this, arguments));
  }

  (0, _createClass2["default"])(MarkdownDisplay, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.data !== this.props.data;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_markdown["default"], {
        source: this.props.data
      });
    }
  }]);
  return MarkdownDisplay;
}(React.Component);

exports.MarkdownDisplay = MarkdownDisplay;
(0, _defineProperty2["default"])(MarkdownDisplay, "MIMETYPE", "text/markdown");
var _default = MarkdownDisplay;
exports["default"] = _default;